module.exports = __webpack_public_path__ + "3f0caa5b20c2dc6c0ab211ba89a612d2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food6.png
// module id = 2458
// module chunks = 0